import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Link } from 'react-router-dom';

const SuccessMessage = ({ applicationId, onStartNew }) => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center">
        <div className="bg-card border border-border rounded-2xl p-8 md:p-12">
          {/* Success Icon */}
          <div className="w-20 h-20 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <Icon name="CheckCircle" size={48} className="text-success" />
          </div>

          {/* Success Message */}
          <h1 className="text-3xl md:text-4xl font-bold text-card-foreground mb-4">
            Application Submitted Successfully!
          </h1>
          
          <p className="text-lg text-muted-foreground mb-8">
            Thank you for choosing DARAJA.LABS. We've received your project application and our team is already reviewing it.
          </p>

          {/* Application Details */}
          <div className="bg-background/50 border border-border rounded-lg p-6 mb-8">
            <div className="flex items-center justify-center space-x-2 mb-4">
              <Icon name="FileText" size={20} className="text-accent" />
              <h3 className="font-semibold text-card-foreground">Application Details</h3>
            </div>
            
            <div className="space-y-2 text-sm">
              <p className="text-muted-foreground">
                <span className="font-medium">Application ID:</span> {applicationId}
              </p>
              <p className="text-muted-foreground">
                <span className="font-medium">Submitted:</span> {new Date()?.toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </p>
              <p className="text-muted-foreground">
                <span className="font-medium">Status:</span> Under Review
              </p>
            </div>
          </div>

          {/* Next Steps */}
          <div className="text-left mb-8">
            <h3 className="font-semibold text-card-foreground mb-4 flex items-center justify-center">
              <Icon name="Clock" size={20} className="mr-2 text-accent" />
              What Happens Next?
            </h3>
            
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-accent rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-accent-foreground text-sm font-bold">1</span>
                </div>
                <div>
                  <p className="font-medium text-card-foreground">Initial Review (24-48 hours)</p>
                  <p className="text-sm text-muted-foreground">
                    Our technical team will review your requirements and assess project scope.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-accent rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-accent-foreground text-sm font-bold">2</span>
                </div>
                <div>
                  <p className="font-medium text-card-foreground">Discovery Call (2-3 business days)</p>
                  <p className="text-sm text-muted-foreground">
                    We'll schedule a call to discuss your project in detail and answer any questions.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-accent rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-accent-foreground text-sm font-bold">3</span>
                </div>
                <div>
                  <p className="font-medium text-card-foreground">Proposal Delivery (3-5 business days)</p>
                  <p className="text-sm text-muted-foreground">
                    You'll receive a detailed proposal with timeline, budget, and project roadmap.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="bg-accent/10 border border-accent/20 rounded-lg p-6 mb-8">
            <h3 className="font-semibold text-card-foreground mb-3">
              Questions? We're Here to Help
            </h3>
            <div className="space-y-2 text-sm">
              <div className="flex items-center justify-center space-x-2">
                <Icon name="Mail" size={16} className="text-accent" />
                <span className="text-muted-foreground">info@daraja.com</span>
              </div>
              <div className="flex items-center justify-center space-x-2">
                <Icon name="Phone" size={16} className="text-accent" />
                <span className="text-muted-foreground">+1 240-598-5442</span>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/home">
              <Button variant="outline" className="w-full sm:w-auto">
                Return to Homepage
              </Button>
            </Link>
            
            <Button 
              variant="default" 
              onClick={onStartNew}
              iconName="Plus"
              iconPosition="left"
              className="w-full sm:w-auto"
            >
              Submit Another Application
            </Button>
          </div>

          {/* Footer Note */}
          <div className="mt-8 pt-6 border-t border-border">
            <p className="text-xs text-muted-foreground">
              You'll receive email updates at each step of the process. 
              Please check your spam folder if you don't see our emails in your inbox.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessMessage;